<template>
  <div
    class="el-core__header menu-header"
    :class="{ _open: isOpen, '_drawer-open': drawerOpen }"
  >
    <app-core-header-left
      :merchant="profile.merchant"
      :account="profile.merchant.account"
      :companyDocument="companyDocument"
      :isOpen="isOpen"
      @appMenuClicked="toggleAppMenu"
    ></app-core-header-left>
    <app-core-header-right
      :merchant="profile.merchant"
      :account="profile.merchant.account"
      :profile="profile.user"
      :isOpen="drawerOpen"
      @openOnboarding="openOnboarding"
      @drawerMenuClicked="toggleDrawerMenu"
    ></app-core-header-right>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatCnpj } from '@/utils/formatCpfCnpj.utils'

export default {
  name: 'AppCoreHeader',
  components: {
    AppCoreHeaderLeft: () =>
      import(
        /* webpackChunkName: "AppCoreHeaderLeft" */ '@/components/project/ui/menu/AppCore/AppCoreHeaderLeft.vue'
      ),
    AppCoreHeaderRight: () =>
      import(
        /* webpackChunkName: "AppCoreHeaderRight" */ '@/components/project/ui/menu/AppCore/AppCoreHeaderRight.vue'
      )
  },
  props: {
    isOpen: {
      type: Boolean
    },
    drawerOpen: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
      accountSettings: 'accountSettings',
      merchantId: 'merchantId',
      accountId: 'accountId'
    }),
    companyDocument: function () {
      if (this.accountSettings.account.document) {
        return formatCnpj(this.accountSettings.account.document)
      }

      return '-'
    }
  },
  methods: {
    toggleAppMenu () {
      this.$emit('appMenuClicked')
    },
    toggleDrawerMenu () {
      this.$emit('drawerMenuClicked')
    },
    openOnboarding () {
      this.$emit('openOnboarding')
    }
  }
}
</script>
<style scoped>
.menu-header {
  z-index: 1099 !important;
  position: relative !important;
}
</style>
